export default __webpack_public_path__ + "static/media/sectionSmallBackground.9a73a84e.png";